const state = {
  storeLanguage:'zh'
};
export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js